import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
    },
  },
  cards: {
    marginBottom: theme.spacing(3),
  },
  container: {
    padding: 0,
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
    },
  },
  bottom: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    whiteSpace: "pre-line",
    "&.Mui-disabled": {
      color: "#CCCCCC",
      backgroundColor: "transparent",
      "& svg": {
        color: "#CCCCCC",
        filter: "invert(66%)",
      },
    },
  },
  date: {
    display: "flex",
    cursor: "pointer",
    "& svg": {
      marginRight: theme.spacing(1),
    },
  },
  dateEditor: {
    width: "350px",
  },
  remindersTitle: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(25),
    color: "#0F172A",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(3),
  },
  cancelButton: {
    borderRadius: "100px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: "19.36px",
    backgroundColor: "#F1F5FF",
    color: "#0344DC",
    border: "0px solid #0344DC;",
  },
  saveButton: {
    borderRadius: "100px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: "19.36px",
    backgroundColor: "#0344DC",
    border: "0px solid #0344DC",
    marginLeft: theme.spacing(2),
  },
  checkbox: {
    marginLeft: "-3px",
    paddingLeft: "0px",
  },
  doneCheck: {
    display: "flex",
    alignItems: "center",
  },
  titleContainer: {
    width: "100%",
  },
  actions: {
    display: "flex",
    alignItems: "start",
    justifyContent: "flex-end",
  },
  editTaskButton: {
    padding: "10px 25px",
    borderRadius: "100px",
    backgroundColor: "transparent",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: "Inter",
    color: "black",
    "&:hover": {
      color: "black",
      backgroundColor: "#E6F1FF",
    },
    "&:active": {
      color: "black",
      backgroundColor: "#CDE3FF",
    },
    "&.Mui-disabled": {
      color: "#CCCCCC",
      backgroundColor: "transparent",
      "& svg": {
        color: "#CCCCCC",
        filter: "invert(66%)",
      },
    },
  },
}));
